import { Editor, useEditor } from '@tiptap/react';
import { EMPTY_RICH_TEXT_CONTENT } from '../../RichTextEditor';
import { ContentType } from './AddScratchpadContent/AddScratchpadContent';
import { extensions } from './ScratchpadRichTextEditor';
import { useCallback } from 'react';

export interface ContentSplitResult {
  beforeHtml: string;
  afterHtml: string;
}

export const useContentSplit = () => {
  const tempEditor = useEditor({
    extensions,
    content: '',
  });

  const splitContent = useCallback(
    (
      editor: Editor,
      type: ContentType,
      handleAddContent: (type: ContentType, split?: ContentSplitResult) => void,
    ) => {
      if (!editor || !tempEditor) {
        return;
      }

      const cursorPos = editor.state.selection.from;
      const doc = editor.state.doc;

      // Create two fragments: before and after cursor
      const beforeFragment = doc.cut(0, cursorPos);
      const afterFragment = doc.cut(cursorPos);

      // Set content and get HTML for before fragment
      tempEditor.commands.setContent(beforeFragment.toJSON());
      const beforeHtml = tempEditor.getHTML();

      // Set content and get HTML for after fragment
      tempEditor.commands.setContent(afterFragment.toJSON());
      const afterHtml = tempEditor.getHTML();

      handleAddContent(type, {
        beforeHtml: beforeHtml || EMPTY_RICH_TEXT_CONTENT,
        afterHtml: afterHtml || EMPTY_RICH_TEXT_CONTENT,
      });
    },
    [tempEditor],
  );

  return { splitContent };
};
